import axios from "axios";
import authHeader from "./auth-header";
// import publicHeader from './public-header';

class PriceService {
  getBrokerFeeSet(feeSetId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/BrokerFeeSet?feeSetId=${feeSetId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getBrokerFeeSets(organizationId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/BrokerFeeSets?organizationId=${organizationId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  createBrokerFeeSet(brokerFeeSet) {
    return axios
      .post(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/BrokerFeeSet`,
        brokerFeeSet,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  updateBrokerFeeSet(brokerFeeSet) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/BrokerFeeSet`,
        brokerFeeSet,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  deleteBrokerFeeSet(feeSetId) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/BrokerFeeSet?feeSetId=${feeSetId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getBrokerFeeAmount(feeSetId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/BrokerFeeAmount?feeSetId=${feeSetId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  createBrokerFeeAmount(brokerFeeAmounts) {
    return axios
      .post(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/BrokerFeeAmount`,
        brokerFeeAmounts,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  updateBrokerFeeAmount(brokerFeeAmounts) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/BrokerFeeAmount`,
        brokerFeeAmounts,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  deleteBrokerFeeAmount(brokerFeeAmounts) {
    return axios
      .delete(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/BrokerFeeAmount`,
        brokerFeeAmounts,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getClosingCostFeeTable(organizationId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/ClosingCostFeeTable?organizationId=${organizationId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  updateClosingCostFeeTable(feeTable) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/ClosingCostFeeTable`,
        feeTable,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  createClosingCostFeeTable(organizationId, selectedDate, feeTable) {
    return axios
      .post(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/ClosingCostFeeTable?organizationId=${organizationId}&startDate=${selectedDate}`,
        feeTable,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  deleteClosingCostFeeTable(feeSetId) {
    return axios
      .delete(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/ClosingCostFeeTable?deletedFeeSetId=${feeSetId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  getLockPeriod(loanNumber) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/LockPeriodList?loanNumber=${loanNumber}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  getPricingByFileData(fileData) {
    return axios
      .post(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/PricingByFileData`,
        fileData,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  getPricingByScenario(scenario) {
    return axios
      .post(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/PricingByScenario`,
        scenario,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  getProgramOptionFieldByLoanNumber(loanNumber) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/ProgramOptionFieldByLoanNumber?loanNumber=${loanNumber}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  generateNonQmFindingReport(loanNumber) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/GenerateNonQmFindingReport?loanNumber=${loanNumber}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  // getResources() {
  //   return axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/LookUp/Resource/FormList?originationChannel=1`,
  //     {
  //       headers: publicHeader()
  //     })
  //     .then(response => {
  //       return response.data;
  //     });
  // }

  // uploadResource(resource) {
  //   return axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/NWAPP/Price/Docs/Update/FormResources`,
  //   resource,
  //     {
  //       headers: authHeader()
  //     })
  //     .then(resp => {
  //       return resp.data;
  //     })
  //     .catch(error => {
  //     });
  // }
}

export default new PriceService();
